import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Sport_specific_performanceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific_performance.svg';
import { ReactComponent as Conditioning_performanceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning_performance.svg';
import { ReactComponent as Strength_powerIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_power.svg';
import { ReactComponent as Speed_agilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed_agility.svg';

interface PerformanceStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  sport_specific_performance: <Sport_specific_performanceIcon />,
  strength_power: <Strength_powerIcon />,
  speed_agility: <Speed_agilityIcon />,
  conditioning: <Conditioning_performanceIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const PerformanceStep3: FC<PerformanceStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'performance',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
